import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.collector_id = parseInt(payload.collector_id, 10)
  payload.provider_id = parseInt(payload.provider_id, 10)
}

var state = {
  netFlowProviders: []
}

var getters = {
  NETFLOW_PROVIDERS: (state) => {
    return state.netFlowProviders
  }
}

var mutations = {
  SET_NETFLOW_PROVIDERS: (state, payload) => {
    state.netFlowProviders = payload
  }
}

var actions = {
  GET_NETFLOW_PROVIDERS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/netflow_providers')
    if (result.status === 200) {
      context.commit('SET_NETFLOW_PROVIDERS', result.data)
    }
  },
  CREATE_NETFLOW_PROVIDERS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/netflow_providers', payload)
  },
  UPDATE_NETFLOW_PROVIDERS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/netflow_providers', payload)
  },
  DELETE_NETFLOW_PROVIDERS: (context, payload) => {
    return axiosInstance.delete('/settings/netflow_providers?provider_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/netFlowProviders.js